import React, { useEffect } from 'react';
import { useClient } from '../../context/ClientProvider';
import GlobalpayPaymentPage from './GlobalpayPaymentPage';
import WorldpayPaymentPage from './WorldpayPaymentPage';


export default function PaymentPage() {
  const { useGetConfig } = useClient();
  const { clientConfig } = useGetConfig();
  const [paymentPage, setPaymentPage] = React.useState<'globalpay' | 'worldpay'>('worldpay');
  
  useEffect(() => {
    if (clientConfig) {
      setPaymentPage(clientConfig?.layout?.payment?.paymentPage ?? 'worldpay');
    }
  }, [clientConfig]);

  if (paymentPage === 'globalpay') {
    return <GlobalpayPaymentPage />;
  } else {
    return <WorldpayPaymentPage />;
  }

}